import { CategoryResolver } from 'parameters/category-resolver';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

export function ParameterRoutes() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={path} exact>
                <div>List</div>
            </Route>
            <Route path={`${path}/:categoryId`}>
                <CategoryResolver />
            </Route>
        </Switch>
    );
}
